'use client';

import { hasVisibleText } from '@/lib/heading.utils';

interface ArticleVideoProps {
  url: string;
  caption?: string | null;
}

export function ArticleVideo({ url, caption }: ArticleVideoProps) {
  return (
    <figure className="my-6 md:my-8">
      <video
        className="w-full aspect-video rounded-2xl bg-black"
        controls
        src={url}
        preload="metadata"
        playsInline
      >
        Ваш браузер не поддерживает видео.
      </video>
      {hasVisibleText(caption) && (
        <figcaption className="text-xs md:text-sm text-muted-foreground mt-3 font-medium break-words">
          {caption?.trim()}
        </figcaption>
      )}
    </figure>
  );
}
